import { useEffect, useState } from "react";
import { useTranslation } from "@/app/i18n/client";
import { CircularDiv } from "@/common/divs";

import { SemiBoldText } from "@/common/texts";
import { TagRef, TagType } from "@/types/components";
import {
  NEUTRO_PARAGRAPHS_COLOR,
  NEUTRO_TITLES_COLOR,
  PRIMARY_BUTTON_COLOR,
  SECONDARY_BUTTON_COLOR,
  WHITE_BUTTON_BORDER_COLOR,
} from "@/utils/constants";

interface TagContainerProps {
  tag: TagType;
  tags: TagRef;
  parseTerm: (term: string) => void;
  deleteAll: boolean;
}

const TagContainer: React.FC<TagContainerProps> = ({
  tag,
  tags,
  parseTerm,
  deleteAll,
}) => {
  const [imSelected, setImSelected] = useState<boolean>(tag.selected);
  useEffect(() => {
    if (deleteAll) {
      setImSelected(false);
    }
  }, [deleteAll]);

  const handleSelectTag = () => {
    setImSelected(!imSelected);
    const foundTag = tags.current.find(
      (tagToFind: TagContainerProps["tag"]) => tagToFind.id === tag.id,
    );
    if (foundTag) {
      foundTag.selected = !foundTag.selected;
    }
    parseTerm(`tag:${tag.id}`);
  };

  const { t } = useTranslation();

  return (
    <CircularDiv
      key={tag.id}
      background={imSelected ? PRIMARY_BUTTON_COLOR : SECONDARY_BUTTON_COLOR}
      height="32px"
      paddingX="16px"
      style={{
        border: "1px solid " + WHITE_BUTTON_BORDER_COLOR,
        cursor: "pointer",
      }}
      width="fit-content"
      onClick={() => {
        handleSelectTag();
      }}
    >
      <SemiBoldText
        fontSize="14px"
        color={imSelected ? NEUTRO_TITLES_COLOR : NEUTRO_PARAGRAPHS_COLOR}
        style={{ marginTop: "-4px" }}
      >
        {t(tag.i18_name)}
      </SemiBoldText>
    </CircularDiv>
  );
};

export default TagContainer;
